import { apiGet } from '@/api/api.ts'
import { useQuery } from '@tanstack/react-query'
import { QueryCacheKeys } from '@/api/queryKeys.ts'
import { createUrl } from '@/util/url.ts'
import { SECOND } from '@/constant/time.ts'

export const DEVICE_SEARCH_MIN_QUERY_LENGTH = 2

export interface IDeviceSearchItem {
    deviceSerial: string
    statusUpdatedAt: string | null
    isOnline: boolean
    inUse: boolean
}

export interface IResSearchDevices {
    devices: IDeviceSearchItem[]
    hasMore: boolean
}

export const apiSearchDevices = async (query?: string) => {
    return await apiGet<IResSearchDevices>(createUrl(`/device/search`, { query }))
}

const useQuerySearchDevices = (query: string, enabled: boolean) => {
    return useQuery({
        queryKey: QueryCacheKeys.device.searchDevices(query),
        enabled,
        staleTime: 30 * SECOND,
        queryFn: async () => {
            const { data } = await apiSearchDevices(query || undefined)
            return data
        }
    })
}

export default useQuerySearchDevices
